import axios from "../../../axios"
import { getCurrentTenant, parseObjectParamsToString, formatGraphqlBody, formatGraphqlParams } from '@/utils'

export default {
  fetch(searchParams = {}) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        query {
          userDepartments ${parseObjectParamsToString(searchParams)} {
            id,
            name,
            activated,
            schedule{
              id,
              messages{
                message,
                message_pause
              },
              value{
                value,
                label,
                start_at,
                finish_at,
                selected,
                start_pause,
                finish_pause
              }
            }
          }
        }
      `
    })
  },
  infos(departmentId) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        query {
          userDepartmentInfos (
            id: ${departmentId}
          ) {
            id,
            name,
            activated
          }
        }
      `
    })
  },
  add(data) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        mutation {
          createUserDepartment (
            name: "${data.name}",
            activated: ${data.activated}
          ) {
            id,
            name,
            activated
          }
        }
      `
    })
  },
  update(data) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        mutation {
          updateUserDepartment (
            id: ${data.id},
            name: "${data.name}",
            activated: ${data.activated}
          ) {
            id,
            name,
            activated
          }
        }
      `
    })
  },
  delete(departmentId) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        mutation {
          deleteUserDepartment (
            id: ${departmentId}
          )
        }
      `
    })
  },
  addSchedule(data){
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    const params = formatGraphqlParams({
      user_department_id: data.user_department_id,
      value: data.value,
      messages: [data.messages]
    });

    return axios.post('', formatGraphqlBody(
      'mutation',
      'createUserDepartmentSchedule',
      {
        0: 'id',
        1: 'user_department_id',
        messages: {
          0: 'message',
          1: 'message_pause'
        },
        value: {
          0: 'value',
          1: 'label',
          2: 'start_at',
          3: 'finish_at',
          4: 'selected',
          5: 'start_pause',
          6: 'finish_pause'
        },
      },
      params
    ))
  },
  deleteSchedule(departmentsId) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        mutation {
          deleteUserDepartmentSchedule (
            user_department_id: [${departmentsId}]
          )
        }
      `
    })
  },
  fetchUserDepartmentByChatTicketId(ids) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql';
    return axios.post('', {
      query: `
        query {
          userDepartmentByChatTicketIdQuery (
            ids: ${ids}
          )
        }
      `
    });
  }
}
